import React, { useEffect, useState, useRef, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Typography, IconButton, Grid, Paper, TextField, Button,
  Dialog, DialogActions, DialogContent, DialogTitle,
  Snackbar,
  Tooltip,
  Chip,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { DataGrid, esES } from '@material-ui/data-grid';
import * as Icons from '@material-ui/icons';
import { Link as RouterLink } from 'react-router-dom';
import NoRowsOverlay from '../components/NoRowsOverlay';
import QuickSearchToolbar from '../components/QuickSearchToolbar';
import moment from 'moment';
import { invokeApig } from '../libs/awsLib';



const useStyles = makeStyles((theme) => ({
  section: {
    margin: theme.spacing(3, 0),
    marginBottom: theme.spacing(10),
    width: 'inherit',
  },
  paper: {
    padding: theme.spacing(2),
  },
  gridMaxMd: {
    [theme.breakpoints.up('md')]: {
      maxWidth: theme.breakpoints.values.lg,
    },
  },
  deleteButton: {
    backgroundColor: '#f44336',
    '&:hover': {
      backgroundColor: '#f44336',
    },
  },
  resetButton: {
    backgroundColor: '#2196f3',
    '&:hover': {
      backgroundColor: '#2196f3',
    },
  },
  textValidate: {
    margin: '15px 0',
  },
  configIcon: {
    color: '#383838',
  },
  editIcon: {
    color: '#2196f3',
  },
  lockIcon: {
    color: '#ff9800',
  },
  deleteIcon: {
    color: '#f44336',
  },
  publishIcon: {
    color: '#4caf50',
  },
  buttonsDialogContainer: {
    padding: '10px 25px',
  },
}));

function escapeRegExp(value) {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

function SitesPage(props) {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [message, setMessage] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
  const [updateSiteData, setUpdateSiteData] = useState({
    name: '',
    description: ''
  });
  
  const [siteId, setSiteId] = useState('');
  const [isDeleteInstance, setIsDeleteInstance] = useState(false);
  const [isUpdateWebsite, setIsUpdateWebsite] = useState(false);
  const [textValidate, setTextValidate] = useState('');
  
  const [sites, setSites] = useState([]);
  const [rows, setRows] = useState(sites);
  const [searchText, setSearchText] = useState('');
  const [openToast, setOpenToast] = useState(false);
  const [messageToast, setMessageToast] = useState('');
  const [openPublishDialog, setOpenPublishDialog] = useState(false);
  const [publishSiteDomain, setPublishSiteDomain] = useState('');
  const [isPublishing, setIsPublishing] = useState(false);
  const pollingRef = useRef(null);
  const sitesRef = useRef([]);
  

  useEffect(() => {
    getSites();
    return () => { if (pollingRef.current) clearInterval(pollingRef.current); };
  }, []);

  // Polling: verifica sitios en CREATING o PUBLISHING cada 15 segundos
  const checkPendingSites = useCallback(async () => {
    const currentSites  = sitesRef.current;
    const creatingSites  = currentSites.filter((s) => s.status === 'CREATING');
    const publishingSites = currentSites.filter((s) => s.status === 'PUBLISHING');

    if (creatingSites.length === 0 && publishingSites.length === 0) {
      if (pollingRef.current) { clearInterval(pollingRef.current); pollingRef.current = null; }
      return;
    }

    for (const site of creatingSites) {
      try {
        const response = await invokeApig({
          path:   '/site/publish-default',
          method: 'POST',
          body:   { domain: site.domain },
        });
        if (response.siteStatus === 'ACTIVE' || response.siteStatus === 'FAILED') {
          getSites();
          return;
        }
      } catch (err) {
        console.error('Error verificando creación de sitio:', err);
      }
    }

    for (const site of publishingSites) {
      try {
        const response = await invokeApig({
          path:   '/site/publish-status',
          method: 'POST',
          body:   { domain: site.domain },
        });
        if (response.siteStatus === 'ACTIVE' || response.siteStatus === 'PUBLISH_FAILED') {
          getSites();
          return;
        }
      } catch (err) {
        console.error('Error verificando publicación de sitio:', err);
      }
    }
  }, []); // eslint-disable-line

  //Obtener sitios
  const getSites = async () => {
    try {
      setIsLoading(true);
      setSites([]);
      setRows([]);
      setSearchText('');
      const response = await invokeApig({
        path: "/site/find",
        method: "POST",
      });
      if (response.statusCode === 200) {
        setSites(response.sites);
        setRows(response.sites);
        sitesRef.current = response.sites;
        // Iniciar polling si hay sitios en CREATING o PUBLISHING
        const hasPending = response.sites.some((s) => s.status === 'CREATING' || s.status === 'PUBLISHING');
        if (hasPending && !pollingRef.current) {
          pollingRef.current = setInterval(() => checkPendingSites(), 15000);
        } else if (!hasPending && pollingRef.current) {
          clearInterval(pollingRef.current);
          pollingRef.current = null;
        }
      } else {
        setMessage('Error al obtener los sitios. Por favor contactar a Soporte.');
        setIsError(true);
      }
    } catch (error) {
      console.error('Error in getAccess:', error);
      setMessage('Error al obtener los sitios . Intenta nuevamente o consulta a Soporte.');
      setIsError(true);
    }
    setIsLoading(false);
  }
  // eliminar sitios 
  const deleteSite = async (siteId) => {
    try {
      setIsLoading(true);
      const response = await invokeApig({
        path: `/site/${siteId}`, 
        method: "DELETE",
        body: {
          domain: siteId,
          
        }
      });

      if (response.statusCode === 200) {
        setMessageToast('Se ha eliminado el Sitio correctamente');
        setOpenToast(true);
        setOpenDialog(false);
        
        // Recargar la lista de sitios
        getSites();
      } else {
        // Manejar diferentes códigos de error
        setMessage(response.message || 'Error al eliminar el Sitio');
        setIsError(true);
      }
    } catch (error) {
      console.error('Error in deleteSite:', error);
      setMessage('Ocurrió un error al eliminar el Sitio. Por favor intenta más tarde o comunícate con Soporte');
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const updateSite = async () => {
    try {
      setIsLoading(true);
      const response = await invokeApig({
        path: `/site`,
        method: "PUT",
        body: {
          ...updateSiteData,
          domain: siteId,
        }
      });
  
      if (response.Status === 0) {
        setMessageToast('Sitio actualizado correctamente');
        setOpenToast(true);
        setOpenUpdateDialog(false);
        getSites(); 
      } else {
        setMessage('Error al actualizar el Sitio');
        setIsError(true);
      }
    } catch (error) {
      console.error('Error in updateSite:', error);
      setMessage('Ocurrió un error al actualizar el Sitio');
      setIsError(true);
    }
    setIsLoading(false);
  };


  const requestSearch = (searchValue) => {
    setSearchText(searchValue);
    const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
    const filteredRows = sites.filter((row) => {
      return Object.keys(row).some((field) => {
        return searchRegex.test(row[field].toString());
      });
    });
    setRows(filteredRows);
  };


  const handleShowDeleteSite = (siteId) => {
    setIsError(false);
    setTextValidate('');
    setSiteId(siteId);
    setIsDeleteInstance(true);
    setOpenDialog(true);
  };
  //Update
  const handleShowUpdateSite = (siteId) => {
    const selectedSite = sites.find(site => site.domain === siteId);
    setUpdateSiteData({
      name: selectedSite.name,
      description: selectedSite.description || ''
    });
    setIsError(false);
    setSiteId(siteId);
    setIsUpdateWebsite(true);
    setOpenUpdateDialog(true);
  };

  const handleUpdateSiteChange = (e) => {
    const { name, value } = e.target;
    setUpdateSiteData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  }
//dejar el de eliminar 
  const handleConfirmAction = () => {                                      
    if (isDeleteInstance && textValidate === 'eliminar sitio') {
      deleteSite(siteId);
    }
  }

  const handleCloseToast = () => {
    setOpenToast(false);
  }

  const handleShowPublishSite = (domain) => {
    setIsError(false);
    setPublishSiteDomain(domain);
    setOpenPublishDialog(true);
  };

  const publishSite = async () => {
    try {
      setIsPublishing(true);
      setIsError(false);
      const response = await invokeApig({
        path:   '/site/publish',
        method: 'POST',
        body:   { domain: publishSiteDomain },
      });
      if (response.statusCode === 200) {
        setMessageToast('Publicación iniciada. El proceso puede tardar 3-5 minutos.');
        setOpenToast(true);
        setOpenPublishDialog(false);
        getSites();
      } else {
        setMessage(response.message || 'Error al iniciar la publicación');
        setIsError(true);
      }
    } catch (error) {
      console.error('Error in publishSite:', error);
      setMessage('Error al iniciar la publicación. Intenta nuevamente o consulta a Soporte.');
      setIsError(true);
    } finally {
      setIsPublishing(false);
    }
  };

  const handleChange = (event) => {
    setTextValidate(event.target.value);
    setIsError(false);
  };
//revisar 
  const columns = [
    {
      field: 'creationDate',
      headerName: 'Fecha',
      flex: 1,
      filterable: false ,
      renderCell: (params) => (
        moment(params.value).format("DD-MM-YYYY HH:mm")
      )
    },
    {
      field: 'domain',
      headerName: 'Dominio',
      flex: 1,
    },
    {
      field: 'name',
      headerName: 'Nombre',
      flex: 1
    },
    {
      field: 'status',
      headerName: 'Estado',
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const state = params.value;
        const STATUS_CONFIG = {
          CREATING:      { label: 'Creando...',       color: '#ff9800', icon: <Icons.HourglassEmpty style={{color: '#fff'}} /> },
          ACTIVE:        { label: 'Activo',           color: '#4caf50', icon: <Icons.Check style={{color: '#fff'}} /> },
          FAILED:        { label: 'Error',            color: '#f44336', icon: <Icons.Error style={{color: '#fff'}} /> },
          PUBLISHING:    { label: 'Publicando...',    color: '#ff9800', icon: <Icons.CloudUpload style={{color: '#fff'}} /> },
          PUBLISH_FAILED: { label: 'Error publicando', color: '#f44336', icon: <Icons.CloudOff style={{color: '#fff'}} /> },
        };
        const cfg = STATUS_CONFIG[state] || { label: state, color: '#9e9e9e', icon: <Icons.Check style={{color: '#fff'}} /> };
        const lastPublished = params.row.lastPublishedAt
          ? moment(params.row.lastPublishedAt).format('DD-MM-YYYY HH:mm')
          : null;
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Chip label={cfg.label} icon={cfg.icon} style={{color: '#fff', backgroundColor: cfg.color}} />
            {lastPublished && (
              <span style={{ fontSize: 10, color: '#757575' }}>Publicado: {lastPublished}</span>
            )}
          </div>
        )
      }
    },
    //botones de accciones  
    {
      field: 'actions',
      headerName: 'Acciones',
      flex: 1,
      filterable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="Configurar Sitio" enterDelay={500} leaveDelay={200}>
            <IconButton component={RouterLink} to={`/site/config/${params.id}`} className={classes.configIcon}>
              <Icons.Settings />
            </IconButton>
          </Tooltip>
          <Tooltip title="Editar Sitio" enterDelay={500} leaveDelay={200}>
            <IconButton onClick={() => handleShowUpdateSite(params.id)} className={classes.editIcon}>
              <Icons.Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title={params.row.designId ? 'Publicar Sitio' : 'Asigna un diseño para publicar'} enterDelay={500} leaveDelay={200}>
            <span>
              <IconButton
                onClick={() => handleShowPublishSite(params.row.domain)}
                className={classes.publishIcon}
                disabled={params.row.status !== 'ACTIVE' || !params.row.designId}
              >
                <Icons.CloudUpload />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Eliminar Sitio" enterDelay={500} leaveDelay={200}>
            <IconButton onClick={() => handleShowDeleteSite(params.id)} className={classes.deleteIcon}>
              <Icons.Delete />
            </IconButton>
          </Tooltip>
        </>
      ),
    }
  ];

  const showConfirmDialog = () => {
    return (
      <Dialog open={openDialog} onClose={handleCloseDialog} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Confirmación</DialogTitle>
        <DialogContent>
          <Alert severity="info">
            <p>{ isDeleteInstance && 'Se va a eliminar el sitio y ya no tendrá acceso. Esta acción no se puede reversar.' }</p>
            <p><b>¿Estás seguro que quieres continuar con la acción?</b></p>
          </Alert>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <TextField
                label="Validación"
                helperText={
                  isDeleteInstance ?
                  "Para eliminar el sitio por favor ingresa el texto 'eliminar sitio'"
                  :
                  "Para reiniciar el ERP por favor ingresa el texto 'reiniciar ERP'"
                }
                name="textValidate"
                value={textValidate}
                onChange={handleChange}
                required
                fullWidth
                className={classes.textValidate}
              />
            </Grid>
          </Grid>
          {
            isError &&
            <Alert severity="error">
              {message}
            </Alert>
          }
        </DialogContent>
        <DialogActions className={classes.buttonsDialogContainer}>
          <Button
            type="button"
            variant="contained"
            className={classes.button}
            onClick={handleCloseDialog}
            disabled={isLoading}
          >
            No, cerra esta ventana
          </Button>
          <Button
            type="button"
            color={isDeleteInstance ? "secondary" : "primary"}
            variant="contained"
            className={isDeleteInstance ? classes.deleteButton : classes.resetButton}
            onClick={handleConfirmAction}
            disabled={isLoading || (isDeleteInstance && textValidate !== 'eliminar sitio')}
          >
            Sí, confirmo
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const showUpdateDialog = () => {
    return (
      <Dialog 
        open={openUpdateDialog} 
        onClose={() => setOpenUpdateDialog(false)} 
        aria-labelledby="update-dialog-title"
      >
        <DialogTitle id="update-dialog-title">Actualizar Sitio</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                name="name"
                label="Nombre del Sitio"
                fullWidth
                value={updateSiteData.name}
                onChange={handleUpdateSiteChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="description"
                label="Descripción"
                fullWidth
                multiline
                rows={4}
                value={updateSiteData.description}
                onChange={handleUpdateSiteChange}
              />
            </Grid>
          </Grid>
          {isError && (
            <Alert severity="error" style={{ marginTop: 15 }}>
              {message}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setOpenUpdateDialog(false)} 
            disabled={isLoading}
          >
            Cancelar
          </Button>
          <Button 
            color="primary" 
            variant="contained"
            onClick={updateSite}
            disabled={isLoading}
          >
            Actualizar
          </Button>
        </DialogActions>
      </Dialog>
    );
  };




  const showPublishDialog = () => (
    <Dialog open={openPublishDialog} onClose={() => setOpenPublishDialog(false)} aria-labelledby="publish-dialog-title">
      <DialogTitle id="publish-dialog-title">Publicar Sitio</DialogTitle>
      <DialogContent>
        <Alert severity="info">
          <p>Se generará el proyecto React y se desplegará en la infraestructura del sitio <b>{publishSiteDomain}</b>.</p>
          <p>El proceso puede tardar <b>3-5 minutos</b>. Podrás ver el progreso en la tabla.</p>
        </Alert>
        {isError && (
          <Alert severity="error" style={{ marginTop: 15 }}>
            {message}
          </Alert>
        )}
      </DialogContent>
      <DialogActions className={classes.buttonsDialogContainer}>
        <Button
          type="button"
          variant="contained"
          onClick={() => setOpenPublishDialog(false)}
          disabled={isPublishing}
        >
          Cancelar
        </Button>
        <Button
          type="button"
          color="primary"
          variant="contained"
          onClick={publishSite}
          disabled={isPublishing}
        >
          {isPublishing ? 'Iniciando...' : 'Publicar'}
        </Button>
      </DialogActions>
    </Dialog>
  );

  return (
    <Grid container spacing={2} className={classes.section} justifyContent="center">
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.gridMaxMd}>
        <Paper className={classes.paper}>
          <Typography variant="h4" gutterBottom>
            Administración de Sitios 
          </Typography>

          <div style={{ height: '430px', width: '100%' }}>
            <DataGrid
              getRowId={(row) => row.domain}
              rows={rows}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5]}
              loading={isLoading}
              components={{
                NoRowsOverlay: NoRowsOverlay,
                Toolbar: QuickSearchToolbar
              }}
              componentsProps={{
                toolbar: {
                  value: searchText,
                  onChange: (event) => requestSearch(event.target.value),
                  clearSearch: () => requestSearch(''),
                  onRefresh: () => getSites(),
                  addButtonUrl: '/sites/form',
                  addButtonText: 'Contratar Sitio '
                },
              }}
              localeText={esES.props.MuiDataGrid.localeText}
            />
          </div>
          { isDeleteInstance && showConfirmDialog()}
          {isUpdateWebsite && showUpdateDialog()}
          {showPublishDialog()}
        </Paper>
      </Grid>
      <Snackbar open={openToast} autoHideDuration={6000} onClose={handleCloseToast}>
        <Alert onClose={handleCloseToast} severity="success">
          {messageToast}
        </Alert>
      </Snackbar>
    </Grid>
  );
}

export default SitesPage;
